import type {CrudFilters, CrudOperators} from '@refinedev/core';

type PhpCrudOperators = 'include' | 'exclude';

const operatorMapping: Record<CrudOperators & PhpCrudOperators, string> = {
  eq: 'eq',
  ne: 'neq',
  lt: 'lt',
  gt: 'gt',
  lte: 'le',
  gte: 'ge',
  in: 'in',
  nin: 'nin',
  ina: 'ina',
  nina: 'nina',
  contains: 'cs',
  ncontains: 'ncs',
  containss: 'css',
  ncontainss: 'ncss',
  between: 'bt',
  nbetween: 'nbt',
  null: 'is',
  nnull: 'nis',
  startswith: 'sw',
  nstartswith: 'nsw',
  startswiths: 'sws',
  nstartswiths: 'nsws',
  endswith: 'ew',
  nendswith: 'new',
  endswiths: 'ews',
  nendswiths: 'news',
  or: 'or',
  and: 'and',
  include: 'include',
  exclude: 'exclude',
};

export const generateFilter = (filters?: CrudFilters) => {
  const queryFilters: {[key: string]: string} = {};

  if (filters) {
    filters.forEach((filter) => {
      if ('field' in filter) {
        const {field, operator, value} = filter;
        const filterKey = `filter`;
        // @ts-ignore
        const mappedOperator = operatorMapping[operator];

        if (mappedOperator === 'or' || mappedOperator === 'and') {
          throw new Error(
            `[@refinedev/simple-rest]: \`operator: ${mappedOperator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`,
          );
        }

        if (field === 'join') {
          queryFilters['join'] = `${value.join(',')}`;
        } else if (mappedOperator === 'is' && value === null) {
          queryFilters[filterKey] = `${field},is,NULL`;
        } else if (mappedOperator === 'bt' && Array.isArray(value)) {
          queryFilters[filterKey] = `${field},bt,${value.join(',')}`;
        } else if (Array.isArray(value)) {
          queryFilters[filterKey] = `${field},${mappedOperator},${value.join(',')}`;
        } else {
          queryFilters[filterKey] = `${field},${mappedOperator},${value}`;
        }
      }
    });
  }
  return queryFilters;
};
